import React from "react";
import {Button } from "@windmill/react-ui"

const FranchiseAllotButton = ({
  id,
  handleFranchiseUpdate,
  end_date,
  start_date,
  package_type
}) => {
  return (
    <>
      <div className="flex justify-end text-right ">
       
          <Button
            onClick={() => handleFranchiseUpdate(id,start_date,end_date,package_type)}
            className="p-2 cursor-pointer text-white-400 hover:bg-green focus:outline-none"
          >
           Allot
          </Button>
     
       
      </div>
    </>
  );
};

export default FranchiseAllotButton;
